import _ from 'lodash';

const useGetDecimal = (value: number) => {
  const numberValue = _.round(value % 1, 2);
  const formattedValue = Math.abs(numberValue || 0);
  const decimal = formattedValue ? `${formattedValue.toFixed(2)}`.substring(1) : '.00';

  return {
    decimal,
    value: value,
  };
};
export default useGetDecimal;
